import { render, staticRenderFns } from "./change-delite-buttons.vue?vue&type=template&id=5d34a977&"
import script from "./change-delite-buttons.vue?vue&type=script&lang=ts&"
export * from "./change-delite-buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports